import { render, staticRenderFns } from "./UserSelectionStep.vue?vue&type=template&id=45497432&scoped=true"
import script from "./UserSelectionStep.vue?vue&type=script&lang=js"
export * from "./UserSelectionStep.vue?vue&type=script&lang=js"
import style0 from "./UserSelectionStep.vue?vue&type=style&index=0&id=45497432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45497432",
  null
  
)

export default component.exports